var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 6.5H6.00011C4.35011 6.5 3.00011 7.85 3.00011 9.5V27.5C3.00011 29.15 4.35011 30.5 6.00011 30.5H30.0001C31.6501 30.5 33.0001 29.15 33.0001 27.5V9.5C33.0001 7.85 31.6501 6.5 30.0001 6.5ZM29.4001 12.875L19.5901 19.01C18.6151 19.625 17.3851 19.625 16.4101 19.01L6.60011 12.875C6.22511 12.635 6.00011 12.23 6.00011 11.795C6.00011 10.79 7.09511 10.19 7.95011 10.715L18.0001 17L28.0501 10.715C28.9051 10.19 30.0001 10.79 30.0001 11.795C30.0001 12.23 29.7751 12.635 29.4001 12.875Z",
    fill: "#114038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.50a9f0af34f0f7ae570ab01911ae660e.svg";
export { ForwardRef as ReactComponent };